import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit, OnChanges {
  @Input() filters;
  @Input() loading;
  @Input() facets;
  @Output() update = new EventEmitter();
  public filterCreateDate;

  constructor() {
  }

  ngOnInit() {
    this.filterCreateDate = (d: Date): boolean => {
      return d <= new Date();
    };
  }

  ngOnChanges(values) {
    if (values.facets) {
      this.initializeFileTypeForm();
    }
  }

  private initializeFileTypeForm() {
    if (this.facets['SEARCH.FACET_FIELDS.FILE_TYPE']) {
      this.facets['SEARCH.FACET_FIELDS.FILE_TYPE'].forEach(fileType => {
        this.filters.fileTypes[fileType.label] = false;
      });
    }

    if (this.facets['SEARCH.FACET_FIELDS.CREATOR']) {
      this.facets['SEARCH.FACET_FIELDS.CREATOR'].forEach(fileType => {
        this.filters.creators[fileType.label] = false;
      });
    }

    if (this.facets['SEARCH.FACET_FIELDS.MODIFIER']) {
      this.facets['SEARCH.FACET_FIELDS.MODIFIER'].forEach(fileType => {
        this.filters.modifiers[fileType.label] = false;
      });
    }
  }
}
